import { render, staticRenderFns } from "./vessel-form.vue?vue&type=template&id=64dd68cf"
import script from "./vessel-form.vue?vue&type=script&lang=js"
export * from "./vessel-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports